import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { AppLookup } from 'src/app/models/lookup.model';
import { ConfigurationFilter, FittingDetail, ProductConfiguration } from '../../../models/fitting-query-params.model';
import * as fromFittings from '../../../store/fromFittings.barrel';
import { selectActiveFittingConfigurationsHasFilter } from '../../../store/fromFittings.barrel';

@Component({
  selector: 'app-specifications',
  templateUrl: './specifications.component.html',
  styleUrls: ['./specifications.component.scss']
})
export class SpecificationsComponent implements OnInit {
  @Input() isAdmin = false;
  @Input() showLoader = false;
  @Input() product?: FittingDetail | null;
  @Input() configurations: ProductConfiguration[] = [];
  @Input() hasDrawing = false;
  @Input() configurationFilter?: ConfigurationFilter | null;
  @Input() configurationsWithoutFilter: ProductConfiguration[] = [];
  @Input() additionalDrawings: string[] = [];
  @Input() activePartNumber?: string;

  @Output() getFittingDrawing = new EventEmitter<string>();
  @Output() getFittingAssociatedDrawing = new EventEmitter<string>();
  @Output() editFittingRecord = new EventEmitter<number>();
  hasFilterApplied$: Observable<boolean> = of(false);

  tappedHoleOptions$: Observable<AppLookup[]> = of([]);
  oringOptions$: Observable<AppLookup[]> = of([]);
  bevelOptions$: Observable<AppLookup[]> = of([]);

  constructor(private store: Store<fromFittings.State>) { }

  ngOnInit(): void {
    this.hasFilterApplied$ = this.store.select(selectActiveFittingConfigurationsHasFilter);
    this.tappedHoleOptions$ = this.store.select(fromFittings.selectConfigurationFilterLookupsTappedHoles);
    this.oringOptions$ = this.store.select(fromFittings.selectConfigurationFilterLookupsOrings);
    this.bevelOptions$ = this.store.select(fromFittings.selectConfigurationFilterLookupsBevels);
  }

  editRecord(fitting: FittingDetail) {
    this.editFittingRecord.emit(fitting.id);
  }

  configurationTopLevelFilterChange(configFilter: Partial<ConfigurationFilter>) {
    this.store.dispatch(fromFittings.changeTopLevelConfigurationFilter({ obj: configFilter }))
  }

  configurationTopLevelFilterChangeTappedBlindOption(option: { value: string, status: boolean }) {
    this.store.dispatch(fromFittings.tappedBlindChangeTopLevel({ obj: option }));
  }

  configurationTopLevelFilterChangeOringOption(option: { value: string, status: boolean }) {
    this.store.dispatch(fromFittings.oringChangeTopLevel({ obj: option }));
  }

  configurationTopLevelFilterChangeBevelOption(option: { value: string, status: boolean }) {
    this.store.dispatch(fromFittings.bevelChangeTopLevel({ obj: option }));
  }


  configurationAssociatePartFilterChange(configFilter: Partial<ConfigurationFilter>) {
    this.store.dispatch(fromFittings.changeAssociateProductConfigurationFilter({ obj: configFilter }))
  }
}
